import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

export const useInfoCard = () => {
  const router = useRouter();
  const onContactSupplierClick = useCallback((): void => {
    router.push(UrlHelper.signup);
  }, [router]);

  return { onContactSupplierClick };
};
